<template>
  <el-select
    :value="value"
    @input="val => $emit('input', val)"
    :disabled="disabled"
    :clearable="true"
    popper-class="tag-type-select-popper"
  >
    <select-option
      v-for="type in visibleTypes"
      :key="type"
      :value="type"
      :label="label(type)"
      :tag="tag(type)"
      :description="description(type)"
      :description-color="descriptionColor(type)"
    />
  </el-select>
</template>

<script>
import SelectOption from '@/common/components/form/SelectOption'
import { TagTypeInfo, TagTypeOrder } from '../enum/TagTypeEnum'

export default {
  name: 'TagTypeSelect',

  components: { SelectOption },

  props: {
    value: {
      required: true
    },

    allowUnenforced: {
      type: Number,
      default: 0
    },

    showExample: {
      type: Boolean,
      default: false
    },

    filteredTypes: {
      type: Array,
      required: false
    },

    disabled: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      TagTypeInfo
    }
  },

  methods: {
    label(type) {
      return this.$t(TagTypeInfo[type].label)
    },

    tag(type) {
      if (TagTypeInfo[type].unenforced && !this.showExample) {
        return {
          type: 'warning',
          text: 'Unenforced'
        }
      } else {
        return null
      }
    },

    description(type) {
      if (this.showExample) {
        return TagTypeInfo[type].example
      } else {
        return null
      }
    },

    descriptionColor(type) {
      if (TagTypeInfo[type].unenforced) {
        return '#cc0000'
      } else {
        return null
      }
    }
  },

  computed: {
    showUnenforced() {
      if (this.allowUnenforced) {
        return (
          this.$store.state.app.features.unenforcedAttributeTypes >=
          this.allowUnenforced
        )
      } else {
        return false
      }
    },

    visibleTypes() {
      let types
      if (this.filteredTypes) {
        types = this.filteredTypes
      } else {
        types = TagTypeOrder
      }

      if (!this.showUnenforced) {
        types = types.filter(type => {
          return !TagTypeInfo[type].unenforced
        })
      }

      if (this.value !== null && !types.includes(this.value)) {
        if (TagTypeInfo[this.value]) {
          types.push(this.value)
        }
      }

      return types
    }
  }
}
</script>

<style>
.tag-type-select-popper {
  min-width: 300px !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/data-manager/components/TagTypeSelect.vue